var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"bg-blue",attrs:{"lg":"5","order-lg":_vm.orderLg}},[_c('section',{staticClass:"text-white d-flex flex-column h-100 overflow-custom"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }